import { render } from "./ImageUploadInput.vue?vue&type=template&id=47ed6503&scoped=true"
import script from "./ImageUploadInput.vue?vue&type=script&lang=js"
export * from "./ImageUploadInput.vue?vue&type=script&lang=js"

import "./ImageUploadInput.vue?vue&type=style&index=0&id=47ed6503&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ed6503"]])

export default __exports__